<app-section-layout [dataForChart]="graphData" [itemTemplate]="productionDivisionGraph" 
(updateNavState)="updateNavState($event)"
></app-section-layout>

<ng-template #productionDivisionGraph let-data="data" let-navInfo="navInfo" let-sectionNavState="sectionNavState">
    <app-production-division-slide [data]="data" [navInfo]="navInfo" [navState]="sectionNavState"></app-production-division-slide>
</ng-template>

<app-real-time-production *ngIf="graphData.subMenu" [graphData]="graphData.subMenu" [selectedBUIndex]="currentBuIndex" [selectedSBUIndex]="currentSbuIndex" ></app-real-time-production>